import React, {
  useCallback,
  useEffect,
  useState,
} from "react";

import {
  Badge,
  Button,
  Dropdown,
  Typography,
} from "antd";

import {
  NotificationOutlined,
} from "@ant-design/icons";

import api from "../api/api";


const NewNotification = ({
  theme,
  darkMode,
  token,
}) => {

  const [notifications, setNotifications] = useState([]);

  const [unreadCount, setUnreadCount] = useState(0);

  const [notificationOpen, setNotificationOpen] = useState(false);

  const [clickedNotificationId, setClickedNotificationId] =
    useState(null);


  const fetchNotifications = useCallback(async () => {

    try {

      const response = await api.get(
        "api/users/notifications/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      const notificationData =
        Array.isArray(response.data)
          ? response.data
          : [];


      const sorted = [...notificationData].sort(
        (a, b) =>
          new Date(b.created_at) -
          new Date(a.created_at)
      );


      setNotifications(sorted);


      setUnreadCount(
        notificationData.filter(
          (item) => !item.is_read
        ).length
      );


    } catch (error) {

      console.error(
        "Notification error",
        error
      );

    }

  }, [token]);


  useEffect(() => {

    fetchNotifications();

  }, [fetchNotifications]);


  const markAsRead = async (id) => {

    try {

      await api.post(
        `api/users/notifications/${id}/mark_as_read/`,
        {
          is_read: true,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      setNotifications(
        (previousNotifications) =>
          previousNotifications.map(
            (item) =>
              item.id === id
                ? {
                    ...item,
                    is_read: true,
                  }
                : item
          )
      );


      setUnreadCount(
        (previousCount) =>
          Math.max(
            0,
            previousCount - 1
          )
      );


    } catch (error) {

      console.error(
        "Failed to mark notification as read:",
        error
      );

    }

  };


  const handleNotificationClick = async (id) => {

    const notification =
      notifications.find(
        (item) => item.id === id
      );


    if (!notification) {
      return;
    }


    setClickedNotificationId(id);


    if (!notification.is_read) {

      await markAsRead(id);

    }


    setTimeout(() => {

      setClickedNotificationId(null);

    }, 500);

  };


  const notificationDropdown = (

    <div
      style={{
        width: 330,
        maxWidth: "calc(100vw - 24px)",
        background: theme.card,
        borderRadius: 18,
        padding: 15,
        boxShadow:
          "0 15px 40px rgba(0,0,0,.15)",
        border:
          `1px solid ${theme.border}`,
        maxHeight: 350,
        overflowY: "auto",
      }}
    >


      <Typography
        style={{
          fontWeight: 800,
          fontSize: 16,
          color: theme.text,
          marginBottom: 10,
          textAlign: "center",
        }}
      >

        Notifications

      </Typography>


      {
        notifications.length > 0
          ? (

            notifications.map(
              (item) => (

                <div
                  key={item.id}
                  onClick={() =>
                    handleNotificationClick(
                      item.id
                    )
                  }
                  style={{
                    padding: "12px 10px",
                    borderRadius: 12,
                    cursor: "pointer",
                    marginBottom: 8,

                    opacity:
                      clickedNotificationId === item.id
                        ? 0.7
                        : 1,

                    transition:
                      "all .2s ease",

                    background:
                      item.is_read
                        ? "transparent"
                        : darkMode
                        ? "#334155"
                        : "#f8fafc",

                    border:
                      `1px solid ${theme.border}`,
                  }}
                >


                  <Typography
                    style={{
                      fontWeight:
                        item.is_read
                          ? 500
                          : 800,

                      fontSize: 13,

                      color: theme.text,
                    }}
                  >

                    {item.message}

                  </Typography>


                  <Typography.Text
                    style={{
                      fontSize: 11,
                      color: theme.secondary,
                    }}
                  >

                    {
                      new Date(
                        item.created_at
                      ).toLocaleString()
                    }

                  </Typography.Text>


                </div>

              )
            )

          )
          : (

            <Typography
              style={{
                textAlign: "center",
                color: theme.secondary,
                padding: "15px 0",
              }}
            >
             No notifications For Now!
            </Typography>

          )
      }


    </div>

  );


  return (

    <Dropdown
      open={notificationOpen}
      onOpenChange={setNotificationOpen}
      placement="bottomRight"
      dropdownRender={() =>
        notificationDropdown
      }
      trigger={["click"]}
    >

      <Badge
        count={unreadCount}
        offset={[0, 0]}
      >

        <Button
          shape="circle"
          icon={
            <NotificationOutlined />
          }
        />

      </Badge>

    </Dropdown>

  );

};


export default NewNotification;